import { ErrorHandler, Injectable } from '@angular/core';
import { ApplicationContextService } from '../services/application-context.service';
import { EnvironmentService } from '../services/environment.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(
        public applicationContext: ApplicationContextService,
        public envService: EnvironmentService
    ){}

    handleError(error: any): void {

        console.log(error);

        const chunkFailedMessage = /Loading chunk .* failed/;

        if (error && error.message && chunkFailedMessage.test(error.message)) {

            let language:string = this.applicationContext.getLanguageCodeFromUrl().toLocaleUpperCase();
            let updateRequiredText = this.envService.settings.updateRequiredNotice[0].text; //0 is the english translation - default to it
            let updateRequiredObject = this.envService.settings.updateRequiredNotice.find((x)=> x.languageCode == language);

            if(updateRequiredObject){
                updateRequiredText = updateRequiredObject.text;
            }

            let updateDeclinedText = this.envService.settings.updateDeclinedNotice[0].text; //0 is the english translation - default to it
            let updateDeclinedObject = this.envService.settings.updateDeclinedNotice.find((x)=> x.languageCode == language);

            if(updateDeclinedObject){
                updateDeclinedText = updateDeclinedObject.text;
            }

            if (confirm(updateRequiredText)) {
                window.location.reload();
            } else {
                alert(updateDeclinedText);
            }
        }

    }
}
